export type Language = 'en' | 'uk';

export interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string, page?: string) => string;
}

export const SUPPORTED_LANGUAGES = {
  en: 'English',
  uk: 'Українська'
} as const;